module.exports = __webpack_public_path__ + "static/media/book_bungei_spine.2abbb9e1.png";